import { render, staticRenderFns } from "./CampaignSetupPixelsListItem.vue?vue&type=template&id=8e4f6742&"
import script from "./CampaignSetupPixelsListItem.vue?vue&type=script&lang=js&"
export * from "./CampaignSetupPixelsListItem.vue?vue&type=script&lang=js&"
import style0 from "./CampaignSetupPixelsListItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports